import { formatDays, formatTime } from "../formatTime"
import { i18n } from "@/i18n"

export const FORMATS = {
  days: "days",
  time: "time",
  percentage: "percentage",
  number: "number",
}

const formatPercentage = (value, isComparing) => {
  if (isComparing) return value

  return `${parseInt(value, 10)}%`
}

export const formatTypes = {
  days: formatDays,
  time: formatTime,
  percentage: formatPercentage,
  // toLocaleString() formats numbers to be language-sensitive, passing "de-DE"
  // adds dots to numbers avobe 999 (example 156235 --> 156.235)
  // @reference: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
  number: value =>
    value !== null && value !== undefined
      ? parseInt(value, 10).toLocaleString(
          i18n.language === "en" ? "en-GB" : "de-DE",
        )
      : value,
}

const setValueTrend = (value, formatter) =>
  value > 0 ? `+${formatter(value, true)}` : `${formatter(value, true)}`

export const kpiValueFormatter = ({ comparisonValue, formatter, value }) => {
  if (value === null || value === undefined) {
    return "-"
  } else if (
    (!!comparisonValue || comparisonValue === 0) &&
    (!!value || value === 0)
  ) {
    return setValueTrend(value - comparisonValue, formatter)
  } else if (formatter) {
    return formatter(value)
  } else {
    return value
  }
}
